import { ReactNode } from 'react';
import { Box } from '@mui/material';

interface ArtifactCardGridProps {
  children: ReactNode;
}

export const ArtifactCardGrid = ({ children }: ArtifactCardGridProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(316px, 1fr))',
        gap: 3,
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
};
